/* eslint-disable no-undef */
import axios from 'axios';

const coreInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  auth: {
    username: import.meta.env.VITE_HJ_BASIC_USERNAME,
    password: import.meta.env.VITE_HJ_BASIC_PASSWORD,
  },
});
coreInstance.interceptors.request.use((config) => {
  return config;
});

const setPartnerChannel = (channel) => {
  if (channel) {
    coreInstance.defaults.headers.common['X-Partner-Channel'] = channel;
  } else {
    delete coreInstance.defaults.headers.common['X-Partner-Channel'];
  }
};

export { coreInstance, setPartnerChannel };
